import { LoginFormData } from 'types/auth';

export const loginFormInitValues: LoginFormData = {
  email: '',
  password: '',
};
